const Figure = ({ src, alt, caption = "" }) => (
  <div>
    <img src={src} alt={alt} />
    {caption && <p>{caption}</p>}
  </div>
);

export default Figure;
